/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_CtaInputs */

const he_landing_cta = /** @type {(inputs: Landing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחילו`)
};

const en_landing_cta = /** @type {(inputs: Landing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Landing_CtaInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_cta = /** @type {((inputs?: Landing_CtaInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_CtaInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_landing_cta(inputs)
	return en_landing_cta(inputs)
});